/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UI = exports.MODEL = exports.LEAD = exports.CONFIGURATION = exports.APP = exports.API = void 0;
exports.API = {
  ERROR: 'API_ERROR',
  RECEIVE: 'API_RECIEVE',
  RESET: 'API_RESET',
  REQUEST: 'API_REQUEST'
};
exports.APP = {
  SAVE_ENV: 'APP_SAVE_ENV'
};
exports.CONFIGURATION = {
  GET: 'CONFIGURATION_GET',
  RECEIVE: 'CONFIGURATION_RECEIVE',
  RESET: 'CONFIGURATION_RESET',
  SET: 'CONFIGURATION_SET',
  SET_CONFIG_CODE: 'CONFIGURATION_SET_CONFIG_CODE',
  STASH: 'CONFIGURATION_STASH'
};
exports.LEAD = {
  CLEAR: 'LEAD_CLEAR',
  SAVE: 'LEAD_SAVE',
  SET_LEAD_IS_VALID: 'SET_LEAD_IS_VALID'
};
exports.MODEL = {
  RECEIVE: 'MODEL_RECEIVE',
  RECEIVE_ALL: 'MODEL_RECEIVE_ALL',
  SET_CURRENT_ID: 'MODEL_SET_CURRENT_ID'
};
exports.UI = {
  CLOSE_MODAL: 'UI_CLOSE_MODAL',
  CURRENT_CATEGORY: 'UI_CURRENT_CATEGORY',
  LAST_SELECTION: 'UI_LAST_SELECTION',
  OPEN_MODAL: 'UI_OPEN_MODAL',
  SET_ACTIVE_VIEW: 'UI_SET_ACTIVE_VIEW',
  SET_FULL_SCREEN: 'UI_SET_FULL_SCREEN'
};